import { useAuth } from "@/context/AuthContext";
import axios from "axios";
import { useRouter } from "next/navigation";
import { useState } from "react";

const TOKEN_EXPIRY_MS = 30 * 24 * 60 * 60 * 1000; // 30 hari

export const useLogin = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const router = useRouter();
  const { saveAuth, setCurrentUser } = useAuth();

  const login = async (credentials) => {
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await axios.post("/api/login", credentials, {
        validateStatus: (status) => status < 500,
      });

      if (response.data?.status === true && response.data?.data?.token) {
        const { token, user } = response.data.data;

        const expiry = Date.now() + TOKEN_EXPIRY_MS;
        localStorage.setItem("tokenExpiry", String(expiry));

        saveAuth({ token });
        setCurrentUser(user);
        setSuccess(true);
        return response.data;
      } else {
        const msg = response.data?.message;
        setError(msg || "Login gagal, coba lagi");
      }
    } catch (err) {
      console.error("Error login:", err);
      setError("Terjadi kesalahan, coba lagi");
    } finally {
      setIsSubmitting(false);
    }
  };

  const logout = () => {
    saveAuth(null);
    setCurrentUser(null);
    delete axios.defaults.headers.common["Authorization"];
    router.push("/auth/login");
  };

  return { login, logout, isSubmitting, error, success };
};
